import type { ThemeVariant } from '@ps/web-spade-types';

export function resolveThemeVariant(themeVariant?: ThemeVariant): ThemeVariant {
  if (themeVariant === 'light') return 'light';
  if (themeVariant === 'dark') return 'dark';

  const prefersLight =
    typeof window !== 'undefined' &&
    !!window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: light)').matches;

  return prefersLight ? 'light' : 'dark';
}
